<template>
  <div>
    <Head title="Neue Prüfung erstellen"/>
    <h1 class="h1">
      Resultat: Fragen wiederholen
    </h1>

    <div class="grid grid-cols-1 lg:grid-cols-2 gap-8">
      <div class="column">
        <h2 class="font-semibold md:text-lg mb-4">{{ __('mistakes.statistics') }}</h2>
        <div class="card">

          <div class="overflow-x-auto relative">
            <table class="w-full text-sm text-left text-gray-500">
              <tbody>
              <tr class="bg-white border-b">
                <th scope="row" class="p-4 text-xs text-gray-700 uppercase bg-gray-50">
                  {{ __('mistakes.right') }}
                </th>
                <td class="py-4 px-6 text-right">
                  {{ correctAnswered.length }}
                </td>
              </tr>
              <tr class="bg-white border-b">
                <th scope="row" class="p-4 text-xs text-gray-700 uppercase bg-gray-50 0">
                  {{ __('mistakes.wrong') }}
                </th>
                <td class="py-4 px-6 text-right">
                  {{ mistakesMade.length }}
                </td>
              </tr>
              <tr class="bg-white border-b">
                <th scope="row" class="p-4 text-xs text-gray-700 uppercase bg-gray-50">
                  {{ __('mistakes.current_tendency') }}
                </th>
                <td class="py-4 px-6 text-right">
                  <tendency :value="0" />
                </td>
              </tr>
              </tbody>
            </table>
          </div>

          <div class="mt-4 flex justify-end">
            <a href="/meine-fehler" class="btn w-auto inline-flex btn-primary">{{ __('mistakes.to_overview') }}</a>
          </div>
        </div>
      </div>

      <div class="column">
        <div class="scrollable mh-[500px] overflow-y-scroll">
          <h2 class="font-semibold md:text-lg mb-4">Fragen verwalten</h2>

          <div class="scrollable mh-[500px] overflow-y-scroll">
            <div class="draggable__wrapper">
              <div v-for="(question, index) in questions" :key="index" @click="showDetails(question)" class="cursor-pointer card mb-2 hover:bg-gray-300">
                <i v-if="question.isCorrect" class="fa fa-thumbs-up text-success-500"></i>
                <i v-else class="fa fa-thumbs-down text-red-500"></i>
                <b class="ml-2">Frage Nr. {{ index + 1 }}: </b>
                <br>
                <span v-html=" question.text.substring(0,80) + '...'"></span>
              </div>
            </div>
          </div>

          <div v-if="playSuccessAnimation" class="absolute top-0 left-0 w-full">
            <lottie-player src="https://assets9.lottiefiles.com/packages/lf20_lg6lh7fp.json" background="transparent" speed="1" style="width: 100%; height: 300px" loop autoplay></lottie-player>
          </div>

        </div>
      </div>
    </div>

    <question-modal :show-modal="showModal" :question="currentQuestion" @close="toggleModal" @mistake-learned="markMistakeAsLearned" />
  </div>
</template>

<script>
import Tendency from './Tendency'
import QuestionModal from './QuestionModal'
import {Head} from '@inertiajs/inertia-vue3'
import {markMistakeAsLearned} from '../../api/MistakeApi'

export default {
  name: 'PracticeResults',

  components: {
    Head,
    Tendency,
    QuestionModal,
  },

  props: {
    questions: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      showModal: false,
      currentQuestion: null,
      playSuccessAnimation: false,
    }
  },

  computed: {

    mistakesMade() {
      return this.questions.filter( question => {
        return ! question.isCorrect
      })
    },

    correctAnswered() {
      return this.questions.filter( question => {
        return question.isCorrect
      })
    },

  },

  methods: {
    getCardClass: function( question ) {
      return ( question.isCorrect ) ? 'bg-green-100 text-green-500' : 'bg-red-100 text-red-500'
    },

    showDetails: function( question ) {
      this.currentQuestion = question
      this.showModal = true
    },

    toggleModal: function() {
      this.showModal = !this.showModal
    },

    markMistakeAsLearned: async function( question ) {
      let result = await markMistakeAsLearned( question.mistake_id )
      if( result ) {
        let index = this.questions.findIndex( (item) => item.id === question.id )
        // eslint-disable-next-line vue/no-mutating-props
        this.questions.splice( index, 1 )
        this.playSuccessAnimation = true
        setTimeout(() => {
          this.playSuccessAnimation = false
          this.checkIfExceeded()
        }, 2000 )
      }
    },
  },
}
</script>

<style scoped>

</style>
